import { render } from "./NewApheresisScreeningForm.vue?vue&type=template&id=cef8f268&scoped=true"
import script from "./NewApheresisScreeningForm.vue?vue&type=script&lang=js"
export * from "./NewApheresisScreeningForm.vue?vue&type=script&lang=js"

import "./NewApheresisScreeningForm.vue?vue&type=style&index=0&id=cef8f268&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cef8f268"]])

export default __exports__